import { Utility } from "../Utils";
var DefaultSearcher = /** @class */ (function () {
    function DefaultSearcher() {
        this.pickerItems = null;
        this.foundItems = [];
    }
    DefaultSearcher.prototype.search = function (query, options, onresults, onerror) {
        var _this = this;
        if (this.tmrId)
            clearTimeout(this.tmrId);
        this.tmrId = setTimeout(function () {
            if (!_this.pickerItems) //TODO updating...
                _this.pickerItems = $map(options.source, options);
            _this.foundItems = Utility.filterItems(_this.pickerItems, query, options);
            _this.tmrId = null;
            onresults(_this.foundItems);
        }, 50);
    };
    return DefaultSearcher;
}());
export { DefaultSearcher };
function $map(source, options) {
    var result = [];
    for (var i = 0; i < source.length; i++) {
        result.push(options.pickerItemFactory(source[i]));
    }
    return result;
}
